export function reviewsSlider(){
    const slider = $(".reviews-slider");

    slider.slick({
        prevArrow: `<button type="button" class="slick-prev">
                        <svg viewBox="0 0 26 19">
                            <path d="M8.762.8a.904.904 0 011.29 0 .91.91 0 010 1.278L3.51 8.62h21.587c.503 0 .903.4.903.904 0 .503-.4.916-.903.916H3.51l6.542 6.53a.926.926 0 010 1.29.904.904 0 01-1.29 0l-8.09-8.091a.888.888 0 010-1.277z"/>
                        </svg>
                    </button>`,
        nextArrow: `<button type="button" class="slick-next">
                        <svg viewBox="0 0 26 18">
                            <path d="M17.639.27a.904.904 0 00-1.29 0 .91.91 0 000 1.278l6.542 6.542H1.304c-.503 0-.903.4-.903.903 0 .504.4.917.903.917h21.587l-6.542 6.53a.926.926 0 000 1.29.904.904 0 001.29 0l8.09-8.091a.888.888 0 000-1.277z"/>
                        </svg>
                    </button>`,
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviews-slider-init.js